import { Loader2 } from "lucide-react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

// Two-button confirmation (archive / delete). Destructive variant uses the
// system destructive token — never colour alone.
export function ConfirmDialog({
  open, onOpenChange, title, description, cancelLabel = "Cancel",
  confirmLabel, onConfirm, destructive = false, busy = false, testid,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" disabled={busy}>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-action"
            disabled={busy}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            className={cn("gap-1.5", destructive && "bg-destructive text-destructive-foreground hover:bg-destructive/90 focus-visible:ring-destructive")}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}{confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
